import { useEffect } from 'react';

const useInitFlowbite = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('flowbite').then((flowbite) => {
        flowbite.initFlowbite(); // Correctly initialize Flowbite
      });
    }
  }, []);
};

export default useInitFlowbite;